export default __webpack_public_path__ + "static/dev-tool-5b2a4d10769a292c6f1ca78a6170e4db.png";